var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.status == 1 ? 'bgc-sgreenone c-greenfour' : 'bgc-sorangeone c-sorangefive'},[_vm._v(" "+_vm._s(_vm.status == 1 ? 'COMPLETO' : _vm.status == 0 ? 'PENDENTE' : 'PENDENTE')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }